// extracted by mini-css-extract-plugin
module.exports = {"destacatsHomeMarato":"destacatshomemarato_destacatsHomeMarato__WdvH_","boto":"destacatshomemarato_boto__pPAXu"};